module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright ©1997 by New York University"), _c('br'), _vm._v("AD rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Feldman, Stephen M., 1955–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Please don’t wish me a merry Christmas : A critical history of the"), _c('br'), _vm._v("separation of church and state / Stephen M. Feldman.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2a"
  }, [_vm._v("p. cm.—(Critical America)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 0-8147-2637-2 (alk paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Church and state—United States—Controversial literature."), _c('br'), _vm._v("2. Christianity and antisemitism—United States. 3. Christianity"), _c('br'), _vm._v("and antisemitism—History. 4. United States—Church history—20th"), _c('br'), _vm._v("century. 5. United States—Politics and government—20th century.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("I. Title.     II. Series..")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("BR516.F44     1997")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("322′.1’09—dc20               96-35601")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("                                            CIP")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America"), _c('br'), _vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0